// @flow

import React from "react";
import type {Product} from "../../models/Product";
import type {translate} from "../../i18next";
import "./GridElement.scss";
import history from "../../history";
import {Link} from "react-router-dom";
import GridPrice from "./GridPrice";
import NscGridPrice from "./NSC/NscGridPrice";
import {isDiscounted} from "../../models/Product";

export type GridElementProps = {
    t: translate,
    product: Product,
    showPrice: boolean,
    needsPickupLocation: boolean,
    showMSRP: boolean,
    isNSCDealer: boolean,
}

const GridElement = (props: GridElementProps) => {
    const galleryImage = props.product.galleryImage || {};
    const TeaserImageStyle = {
        backgroundImage: "url(" + (galleryImage.previewImage || {}).attachmentUrl + ")"
    };
    const {carlines} = props.product;
    const isSalesPrice = isDiscounted(props.product);

    const renderFitments = () => {
        const FITMENTS_MAX_LENGTH = 34;
        let fitmentsString = carlines[0] || props.t("productDetail.all");

        for (let i = 1; i < carlines.length; i++) {
            if (fitmentsString.length + carlines[i].length > FITMENTS_MAX_LENGTH) {
                return (`${fitmentsString}, ...`);
            }
            fitmentsString += (`, ${carlines[i]}`);
        }
        return fitmentsString;
    };

    const showSaleBadge = props.showPrice && isSalesPrice && !props.isNSCDealer;
    const showAssemblyBadge = !!props.product.distributionChannels.mounting;

    let className = "hpm-gridElement";
    if (showSaleBadge) {
        className = `${className} discounted`;
    }
    if (showAssemblyBadge) {
        className = `${className} mounting`;
    }

    return (
        <Link to={history.getProductUrl(props.product.id, props.product.name.replace("%", ""))} className={className}>
            <div>
            <div className="hpm-teaserImageWrapper">
                <div aria-label={galleryImage?.caption || props.product.name} className="hpm-teaserImage"
                     style={TeaserImageStyle}>
                    {showAssemblyBadge &&
                        <div className="hpm-cornerBadge hpm-cornerBadge--assembly"
                             title={props.t("category.assemblyHint")}>
                            <span className="hpm-cornerBadge__label">{props.t("category.assemblyHint")}</span>
                            <span className="hpm-cornerBadge__icon" aria-hidden="true"/>
                        </div>}
                    {showSaleBadge &&
                        <div className="hpm-cornerBadge hpm-cornerBadge--sale"
                             title={props.t("category.saleHint")}>
                            <span className="hpm-cornerBadge__icon" aria-hidden="true"/>
                            <span className="hpm-cornerBadge__label">{props.t("category.saleHint")}</span>
                        </div>}
                </div>
            </div>
            <div className="hpm-textWrapper">
                <div className="hpm-title" title={props.product.name}>{props.product.name}</div>
                <div className="hpm-description">{renderFitments()}</div>
            </div>
            </div>
            {props.isNSCDealer ? <NscGridPrice {...props} /> : <GridPrice {...props} />}
        </Link>
    );
};

export default GridElement;
